import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow } from "vue"
import _imports_0 from '@/assets/img/svg/card-default.svg'


const _hoisted_1 = {
  key: 0,
  class: "avatar"
}
const _hoisted_2 = { class: "avatar__initials" }
const _hoisted_3 = {
  key: 0,
  class: "avatar__img"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "system avatar"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  alt: "avatar",
  class: "ava"
}
const _hoisted_8 = {
  key: 2,
  style: {"width":"100%","height":"100%, position: absolute","top":"0","left":"0"}
}
const _hoisted_9 = { class: "user-status" }

import { onMounted, watch } from "vue";
import { useAvatar } from "@/composition/user/useAvatar";
import { useLazyLoading } from "@/composition/general/useLazyLoading";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultUserAvatar',
  props: {
    avatar: null,
    userInitials: null,
    isSystemAvatar: { type: Boolean },
    showMark: { type: Boolean },
    disableLazyLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  avatar: null | string;
  userInitials: string;
  isSystemAvatar?: boolean;
  showMark?: boolean;
  disableLazyLoading?: boolean;
}



const { lazyOptions, setFileUrl, error, loading } = useLazyLoading();

watch(
  () => props.avatar,
  (value) => {
    if (value && !props.disableLazyLoading) {
      setFileUrl(value);
    }
  }
);

onMounted(() => {
  if (props.avatar && !props.disableLazyLoading) {
    setFileUrl(props.avatar);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_skeletor = _resolveComponent("skeletor")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.avatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.isSystemAvatar || !__props.userInitials || _unref(error))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(useAvatar)(__props.avatar, __props.userInitials)), 1)
                ], 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.disableLazyLoading)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.avatar,
                alt: "avatar",
                class: "ava"
              }, null, 8, _hoisted_6))
            : _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_7, null, 512)), [
                [_directive_lazy, {
        src: _unref(lazyOptions).src,
        lifecycle: _unref(lazyOptions).lifecycle,
        delay: 100,
      }]
              ])
        ], 64)),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_skeletor, {
            circle: "",
            as: "div",
            width: '100%',
            height: '100%',
            class: "avatar__skeleton",
            style: {"position":"absolute","top":"0","left":"0"}
          })
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
      [_vShow, __props.showMark]
    ])
  ], 64))
}
}

})